import React from 'react';
import { Typography, Grid, Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { Frame, DataGrid, Utils, Formatter } from 'ecrion-components';
import * as gridTranslateClient from '../../utils/gridTranslateClient';
import { useAsync } from 'react-async';

const Integration = (props) => {
  const { appId, extensionType, url, sections } = props;

  return (
    <div>
      {extensionType === 'backend' && (
        <Grid container spacing={3} direction="column">
          {sections.map((section) => (
            <Grid item key={section.name}>
              <Typography variant="h6" gutterBottom>
                {section.name}
              </Typography>
              <IntegrationGrid
                appId={appId}
                url={section.src}
                name={section.name}
              />
            </Grid>
          ))}
        </Grid>
      )}
      {extensionType === 'frontend' && <Frame.FrameBase url={url} />}
    </div>
  );
};

const getData = ({ appId, url }) => {
  return gridTranslateClient.getData(appId, url);
};

const IntegrationGrid = ({ appId, url, name }) => {
  const { data, error } = useAsync({
    promiseFn: getData,
    appId,
    url,
  });

  if (error)
    return (
      <Typography color="error">{error.message || error.Message}</Typography>
    );

  return (
    <>
      {data && (
        <DataGrid
          id={name}
          dataType="extensions"
          idKeyProp={data.IdSrc}
          dataProps={{ appId, url }}
          viewProps={{ hideModeSwitcher: true }}
          styles={{ elevation: 0 }}
          columns={data.Columns.map((column) => ({
            id: column.Id,
            children: column.Name,
            formatter: ({ data }) => (
              <CellFormatter data={data} column={column} />
            ),
            serverSort: column.Sortable,
          }))}
        />
      )}
    </>
  );
};

const decomposeRelativeURL = (url) => {
  const urlObj = { pathname: '', search: '', hash: '' };
  const searchIdx = url.indexOf('?');
  const hashIdx = url.indexOf('#');

  if (searchIdx !== -1) {
    urlObj.pathname = url.substring(0, searchIdx);
    if (hashIdx !== -1) {
      urlObj.search = url.substring(searchIdx, hashIdx);
      urlObj.hash = url.substring(hashIdx);
    } else {
      urlObj.search = url.substring(searchIdx);
    }
    return urlObj;
  }

  if (hashIdx !== -1) {
    urlObj.pathname = url.substring(0, hashIdx);
    urlObj.hash = url.substring(hashIdx);
    return urlObj;
  }

  urlObj.pathname = url;
  return urlObj;
};

const CellFormatter = ({ data, column }) => {
  let value = Utils.getDotProp(data, column.Src);

  let Component = ({ value }) => value;

  if (Formatter[column.FormatterType]) {
    Component = Formatter[column.FormatterType];
  }

  if (column.ToSrc) {
    const url = Utils.getDotProp(data, column.ToSrc);
    const isRelativeUrl =
      !url.startsWith('http://') && !value.startsWith('https://');

    if (!isRelativeUrl) {
      return (
        <Formatter.Link
          openInNewTab
          text={<Component value={value} />}
          value={url}
          to={url}
          component={Link}
        />
      );
    }

    const location = {
      ...decomposeRelativeURL(url),
      state: {
        from: {
          pathname: window.location.pathname,
          search: window.location.search,
          hash: window.location.hash,
        },
      },
    };
    return (
      <Formatter.Link
        text={<Component value={value} />}
        value={url}
        to={location}
        component={RouterLink}
      />
    );
  }

  const formatterProps = {};
  if (column.FormatterProps) {
    column.FormatterProps.forEach((prop) => {
      formatterProps[prop.Name] =
        prop.Value || Utils.getDotProp(data, prop.Src);
    });
  }

  return <Component value={value} {...formatterProps} />;
};

export default Integration;
